import React from 'react';

import { SVGComponentProps } from './svg.types';

const CopySVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.25 10.5H10.499V12.25C10.4991 12.4798 10.454 12.7073 10.3662 12.9196C10.2783 13.1319 10.1495 13.3249 9.98708 13.4874C9.82466 13.6499 9.63181 13.7788 9.41955 13.8668C9.20728 13.9547 8.97977 14 8.75 14H1.75C1.28587 14 0.840752 13.8156 0.512563 13.4874C0.184375 13.1592 2.86067e-07 12.7141 2.86067e-07 12.25V5.25C-0.00013117 5.02015 0.0450442 4.79253 0.132943 4.58015C0.220843 4.36777 0.349742 4.1748 0.51227 4.01227C0.674799 3.84974 0.86777 3.72084 1.08015 3.63294C1.29253 3.54504 1.52015 3.49987 1.75 3.5H3.499V1.75C3.499 1.5201 3.5443 1.29246 3.63231 1.08007C3.72031 0.867688 3.84931 0.674725 4.01192 0.51221C4.17453 0.349694 4.36756 0.220811 4.58 0.132924C4.79243 0.0450371 5.0201 -0.000131084 5.25 2.8574e-07H12.25C12.7141 2.8574e-07 13.1592 0.184375 13.4874 0.512563C13.8156 0.840752 14 1.28587 14 1.75V8.75C14 8.97981 13.9547 9.20738 13.8668 9.4197C13.7788 9.63202 13.6499 9.82493 13.4874 9.98744C13.3249 10.1499 13.132 10.2788 12.9197 10.3668C12.7074 10.4547 12.4798 10.5 12.25 10.5ZM12.25 1.75H5.25V3.5H8.75C8.97977 3.5 9.20728 3.54527 9.41955 3.63323C9.63181 3.72119 9.82466 3.85011 9.98708 4.01262C10.1495 4.17514 10.2783 4.36807 10.3662 4.58038C10.454 4.79269 10.4991 5.02023 10.499 5.25V8.75H12.25V1.75Z"
          fill="#878A92"
        />
      </svg>
    </span>
  );
};

export default CopySVG;
